// @flow
import { defineMessages } from 'react-intl';

const messages = defineMessages({
    beta: {
        defaultMessage: 'BETA',
        description: 'Text for the beta badge',
        id: 'boxui.badges.beta',
    },
    trial: {
        defaultMessage: 'TRIAL',
        description: 'Text for the trial badge',
        id: 'boxui.badges.trial',
    },
    upgrade: {
        defaultMessage: 'UPGRADE',
        description: 'Text for the upgrade badge',
        id: 'boxui.badges.upgrade',
    },
});

export default messages;
